import { Controller } from "@hotwired/stimulus"

// Handles selection in the custom dropdown list for SelectComponent.
// Updates the hidden field value and active item styling.
export default class extends Controller {
  static targets = ["item", "input", "list", "button", "label"]

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    document.addEventListener("click", this.handleDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
  }

  toggle(event) {
    event.preventDefault()
    if (this.hasListTarget) {
      this.listTarget.classList.toggle("is-open")
    }
  }

  select(event) {
    // console.log("Select Dropdown Controller: select method");
    const clicked = event.currentTarget
    const value = clicked.dataset.value

    this.itemTargets.forEach((el) => {
      el.classList.remove("dropdown-item--active")
    })

    clicked.classList.add("dropdown-item--active")

    if (this.hasInputTarget) {
      this.inputTarget.value = value
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = clicked.textContent.trim()
    }

    if (this.hasListTarget) {
      this.listTarget.classList.remove("is-open")
    }
  }

  handleDocumentClick(event) {
    if (!this.hasListTarget) return
    if (!this.listTarget.classList.contains("is-open")) return

    // If the click is inside this component, ignore it
    if (this.element.contains(event.target)) return

    this.listTarget.classList.remove("is-open")
  }
}
